
import Vue from 'vue'
import { Component, Watch } from 'vue-property-decorator'
import Modal from '@/components/Modal.vue'
import { ModalSize } from '@/components/modal-size'
import { setOnboardingToLive } from '@/api/onboarding'
import { Action } from 's-vuex-class'
import confetti from '@/utils/fancyConfetti'
import { notifySuccess } from '@/utils/notices'

@Component<TestModeModal>({
    components: { Modal },
})
export default class TestModeModal extends Vue {
    public isConfirmed = false
    public confirmationText = ''

    @Action public setShowTestMode

    public get modalSize() {
        return ModalSize
    }

    @Watch('confirmationText')
    private onConfirmationTextChanged(confirmationText: string) {
        if (confirmationText.toLowerCase().trim() === 'yes') {
            this.isConfirmed = true
            return
        }
        this.isConfirmed = false
    }

    private async disableOnboardingMode() {
        if (this.isConfirmed) {
            const { data } = await setOnboardingToLive()
            if (data.success) {
                this.setShowTestMode(false)
                this.showConfetti()
                notifySuccess(
                    `
                    <div style="font-size: 20px; padding-bottom: 8px;">You’ve gone live!</div>
                    <div style="font-size: 12px;">
                        Congratulations, now you can start sending real surveys and getting feedback from your customers!
                    </div>
                `,
                    {
                        pos: 'top-right',
                        timeout: 5000,
                    }
                )
            }

            this.$emit('close')
        }
    }

    private showConfetti() {
        confetti.init('body-main', 1000)
        confetti.start(1000, 1000, 1000)
    }
}
